import { defineComponent, h, useAttrs } from 'vue'
import { VOverlay } from 'vuetify/components'

function normalizeModelValue(value) {
  if (value === false || value === 'false' || value == null) return false
  if (value === '' || value === true || value === 'true') return true
  return Boolean(value)
}

function normalizeAttrs(attrs) {
  const normalized = { ...attrs }

  if (normalized.modelValue == null && attrs.value !== undefined) {
    normalized.modelValue = normalizeModelValue(attrs.value)
  } else if (normalized.modelValue !== undefined) {
    normalized.modelValue = normalizeModelValue(normalized.modelValue)
  } else {
    normalized.modelValue = true
  }

  delete normalized.value

  // Vuetify 2's <v-overlay> centered its content by default. Vuetify 3 only
  // applies its centering classes (v-overlay--justify-center/--align-center)
  // when a `location` prop is explicitly given (VOverlay/locationStrategies.js
  // getStaticLocationClasses returns undefined for the unset default), so an
  // unmodified <v-overlay> now anchors content to the top-left instead. Match
  // V2's default unless the caller already opted into their own location.
  if (normalized.location == null) {
    normalized.location = 'center'
  }

  return normalized
}

export default defineComponent({
  name: 'VOverlayCompat',
  compatConfig: {
    RENDER_FUNCTION: false,
    COMPONENT_V_MODEL: false,
    INSTANCE_ATTRS_CLASS_STYLE: false
  },
  inheritAttrs: false,
  emits: ['update:modelValue', 'input'],

  setup(_, { emit, slots }) {
    const attrs = useAttrs()

    return () =>
      h(
        VOverlay,
        {
          ...normalizeAttrs(attrs),
          'onUpdate:modelValue': (value) => {
            emit('update:modelValue', value)
            emit('input', value)
          }
        },
        slots
      )
  }
})
